import React , {Component} from "react";
import { PnkConnect } from '../../pnk-react/pnk-miniredux';
import UpcomingSessionsPage from "./upcoming-session";

class upcomingSessions extends Component{
    // constructor(){
    //     super();

    // }
        render() {
            return(
                <div>
                <UpcomingSessionsPage {...this.props}/>
                </div>
            )
       
    }
}

export const UpcomingSessions = PnkConnect(upcomingSessions , '');